import SectionHero from '@/components/SectionHero';
import DefaultSolutionTemplate from '@/components/templates/Solution';
import { sdk } from '@/lib/graphcms';

export default function AgileEcommerce({ solution }) {
  return (
    <DefaultSolutionTemplate page={solution}>
      <SectionHero
        title="Headless content-powered commerce at an enterprise scale"
        description="With industry leading performance, a wide technology ecosystem, and unmatched GraphQL APIs, GraphCMS helps you scale your eCommerce business to unforeseen heights."
      />
    </DefaultSolutionTemplate>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { solution } = await sdk({ preview }).useCasePage({
    slug: 'agile-ecommerce',
  });

  if (!solution) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      solution,
    },
    revalidate: 3600,
  };
};
